import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Drawer } from 'antd'

import { server, stringifyDate, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'

const Document = () => {
    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error, data }] = usePet('singleHostedDocument', { id }, { notify: true })

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="50%">
            <p className="font-extrabold text-3xl mb-0">{ data ? data?.name : "Hosted Document" }</p>
            <p className="text-gray-500 text-xs italic mb-2">Version { data?.previous?.length + 1 } updated on { stringifyDate(data?.date) }</p>
            <Receive
                loading={loading}
                error={ error }
                progress>
                {
                    data &&   
                    <iframe width="100%" height="768px" src={ `${server}/uploads/hosted-documents/${data?.fileName}?session=${sessionStorage.getItem('token')}`} />
                }
            </Receive>
        </Drawer>
    )
}

export default Document